import { array2map } from '@Ravnur-Inc/core/transformers/array-to-map';
import identity from '@Ravnur-Inc/nanoutils/identity';

import { NestedEntity } from '@/types/Entity';

export type Checkable<E extends Entity> = {
  entity: E;
  checked: boolean;
} & Entity;

export type CheckableNested<E extends NestedEntity> = {
  parentId: Nullable<string>;
} & Checkable<E>;

export function toCheckable<E extends Entity>(
  list: E[],
  selected: string[] = []
): Array<Checkable<E>> {
  const cache = array2map(selected);
  return list.map((entity) => ({
    id: entity.id,
    entity,
    checked: cache[entity.id] || false,
  }));
}

export function toCheckableNested<E extends NestedEntity>(list: E[]): Array<CheckableNested<E>> {
  return list.map((entity) => ({
    id: entity.id,
    parentId: entity.parentId,
    entity,
    checked: false,
  }));
}

type EtityGetter = <E extends Entity>(arr: Array<Checkable<E>>) => E[];
export const getChecked: EtityGetter = createCheckedGetter(true, identity);
export const getUnChecked: EtityGetter = createCheckedGetter(false, identity);

export function createCheckedGetter<E extends Entity, T = E>(flag: boolean, getter: (e: E) => T) {
  return function _inner(list: Array<Checkable<E>>): T[] {
    return list.reduce((memo: T[], { checked, entity }: Checkable<E>) => {
      if (checked === flag) {
        memo.push(getter(entity));
      }
      return memo;
    }, []);
  };
}
